import { useMutation } from '@tanstack/react-query';
import { BodyCreateDatasetApiV1DatasetDatasetNamePost } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';

export const useUploadDataset = () => {
  return useMutation(
    async (
      payload: BodyCreateDatasetApiV1DatasetDatasetNamePost & {
        name: string;
        metadata: { manual?: boolean; description: string; name: string };
      }
    ) => {
      const datasetName = payload.name;

      const { data: table } =
        await datasetApi.createDatasetApiV2DatasetsDatasetNamePost(
          datasetName,
          {
            metadata: payload.metadata,
          },
          getDatasetRequestConfig()
        );

      await datasetApi.replaceDatasetApiV2DatasetsDatasetNameDataPut(
        datasetName,
        {
          encoding: payload.encoding,
          file: payload.file,
          dynamic: payload.dynamic,
        },
        getDatasetRequestConfig()
      );

      return table;
    }
  );
};
